/**
 * How the VIP live banner turns its favourites by itself: every so many
 * seconds, or 0 for by hand only. Kept per player, on the device.
 */
export const ROTATION_CHOICES = [0, 3, 5, 10] as const;

const DEFAULT_SECONDS = 5;
const STORAGE_KEY = 'tottalo.vipHeroRotation';

const keyOf = (player: number | undefined) =>
  `${STORAGE_KEY}.${player ?? 'guest'}`;

export function readHeroRotation(player: number | undefined): number {
  try {
    const stored = Number(localStorage.getItem(keyOf(player)) ?? NaN);
    if ((ROTATION_CHOICES as readonly number[]).includes(stored)) return stored;
  } catch {
    // Private mode: fall through to the default.
  }
  const still = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  return still ? 0 : DEFAULT_SECONDS;
}

export function saveHeroRotation(player: number | undefined, seconds: number) {
  try {
    localStorage.setItem(keyOf(player), String(seconds));
  } catch {
    // Private mode: the choice still applies for this page load.
  }
}
